<template>
  <div class="container">
    <top-menu :current="['mall']"></top-menu>

    <div class="main-container">

      <div class="mall-box" v-for="item in activities" :key="item.title">
        <router-link :to="{ name: 'Quote', query: { bname: item.brand_name, sname: item.series_name } }" class="summary-series__news-card-a"><img
            :src="item.img_url"
            class="mall-box__img"
          />
          <div class="mall-box-info">
            <h5 class="mall-box-info__title">{{item.title}}</h5>
            <p class="mall-box-info__discount">{{ item.discount }}</p>
          </div>
        </router-link>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopMenu from "@/components/Menu";
import Footer from "@/components/Footer";
export default {
  name: "Index",
  components: {
    TopMenu,
    Footer
  },
  data() {
    return {
      activities:[
        {
          img_url: 'https://image.bitautoimg.com/brandmarket/goods/image/20210226/6374994378098331683838458.jpg',
          title: '吉利新帝豪GL UP',
          discount: '现金优惠至高3000元',
          brand_name: '吉利',
          series_name: '帝豪GL'
        },
        {
          img_url: 'https://image.bitautoimg.com/brandmarket/goods/image/20200424/6372334545663387913879017.jpg',
          title: 'BMW 1系运动轿车',
          discount: '悦享48期0首付',
          brand_name: '宝马',
          series_name: '宝马1系'
        },
         {
          img_url: 'https://image.bitautoimg.com/brandmarket/goods/image/20210226/6374995920289628832973168.png',
          title: '捷途X70 PLUS',
          discount: '爆款钜惠20亿',
          brand_name: '吉利',
          series_name: '捷途'
        },
         {
          img_url: 'https://image.bitautoimg.com/brandmarket/goods/image/20200731/6373180862689550077672752.jpg',
          title: '比亚迪享分期0利息，首付低至15%',
          discount: '再享万元置换补贴',
          brand_name: '比亚迪',
          series_name: ''
        },
         {
          img_url: 'https://image.bitautoimg.com/brandmarket/goods/image/20201031/6373975170623662907882806.png',
          title: '购沃尔沃S60享日供3元起',
          discount: '至高15000元置换补贴',
          brand_name: '沃尔沃',
          series_name: 'S60'
        }
      ]
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {},
  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
}
.main-container {
  margin: 0.8rem;

  .mall-box {
    background: #fff;
    padding: 0;
    margin-bottom: 10px;
    font-size: 14px;
    border-radius: 10px;
    overflow: hidden;
    .mall-box__img {
      width: 100%;
    }
    .mall-box-info {
      background: #fff;
      text-align: center;
      padding: 5px 0;

      .mall-box-info__title {
        color: #666;
        margin-top: 5px;
        font-size: 15px;
      }
      .mall-box-info__discount {
        color: #ff4b3c;
        font-size: 16px;
        margin-bottom: 5px;
      }
    }
  }
}
</style>

